export default "__VITE_ASSET__De25EMQj__"